import { render, staticRenderFns } from "./AprovarContratoManual.vue?vue&type=template&id=7bdfd957&"
import script from "./AprovarContratoManual.vue?vue&type=script&lang=js&"
export * from "./AprovarContratoManual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports